import { render, staticRenderFns } from "./MapMainMenu.vue?vue&type=template&id=2ad115f4&"
import script from "./MapMainMenu.vue?vue&type=script&lang=js&"
export * from "./MapMainMenu.vue?vue&type=script&lang=js&"
import style0 from "./MapMainMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports